import { TypeDescription } from '../typing/type-description.js';
import { ObjectTypeDescription } from '../typing/object-type-description.js';
import { object } from '../typing/object.js';
import { getJsonSchemaDescription } from '../json-schema/json-schema.js';
import type { EventDeclaration } from '../event-store/event-declarations.js';
import type { EventPropsOutput } from './event-props-output.js';

export { type EventPropsOutput } from './event-props-output.js';

export function declareEvent<
  T extends {
    [key: string]: TypeDescription;
  },
  K extends string,
>(key: K, props: T): EventDeclaration<EventPropsOutput<T>> & { key: K } {
  const type = object('event', props) as ObjectTypeDescription<
    EventPropsOutput<T>
  >;
  const schema = getJsonSchemaDescription(type);
  return {
    type,
    schema,
    key,
  };
}
